module.exports = __webpack_public_path__ + "img/flying.013ff0bc.svg";